// DS: PO51
import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Modal from '../Popup/Modal';
import FooterButton from '../Popup/_partials/DialogCardLayout/FooterButton';
import s from './CompletionPopup.scss';
export const CompletionPopup = ({ image, imageWidth, imageHeight, imageWidthMobile, imageHeightMobile, title, message, buttonLabel, isLoading, footerless, init, onClose, close })=>{
    const { t } = useTranslation();
    useEffect(()=>init && init(), [
        init
    ]);
    const isMobile = useContext(MobileContext);
    const handleClose = ()=>{
        close();
        onClose && onClose();
    };
    const renderFooter = ()=>{
        if (footerless) {
            return null;
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: s['footer']
        }, /*#__PURE__*/ React.createElement(FooterButton, {
            size: "medium",
            onClick: handleClose
        }, buttonLabel || t('common.ok')));
    };
    const renderMobile = ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: s['body']
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['title']
        }, title), /*#__PURE__*/ React.createElement("img", {
            className: s['image'],
            src: image,
            width: imageWidthMobile || imageWidth,
            height: imageHeightMobile || imageHeight,
            alt: "",
            loading: "lazy"
        }), /*#__PURE__*/ React.createElement("div", {
            className: s['message']
        }, message)), renderFooter());
    const renderDesktop = ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: s['body']
        }, /*#__PURE__*/ React.createElement("img", {
            className: s['image'],
            src: image,
            width: imageWidth,
            height: imageHeight,
            alt: "",
            loading: "lazy"
        }), /*#__PURE__*/ React.createElement("section", {
            className: s['text-section']
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['title']
        }, title), /*#__PURE__*/ React.createElement("div", {
            className: s['message']
        }, message))), renderFooter());
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: true,
        isLoading: isLoading,
        contentClassName: s['root'],
        onRequestClose: handleClose
    }, isMobile ? renderMobile() : renderDesktop());
};
CompletionPopup.displayName = 'CompletionPopup';
export default CompletionPopup;
